import Button from '@pelckmans/elementis/components/button';
import PlusIcon from '@pelckmans/elementis/icons/plus';
import { useTranslation } from 'react-i18next';
import { useRoutes } from '../../../../../hooks/useRoutes';
import EmptyState from '../../../../../shared-components/EmptyState';

const BASE = 'PAGES.ASSIGNMENTS.TEACHER.EMPTY_STATE.NO_GROUPS';

function GroupsEmptyState({ id }: { id: string }) {
  const { t } = useTranslation();
  const { buildAbsolutePath } = useRoutes();

  return (
    <EmptyState
      id={id}
      variant="table"
      headerTitle={t(`${BASE}.TITLE`)}
      bodyText={t(`${BASE}.TEXT`)}
      cta={
        <Button
          prominence="secondary"
          startIcon={<PlusIcon />}
          size="md"
          as="link"
          href={`${buildAbsolutePath(['MY_GROUPS'])}`}
        >
          {t(`${BASE}.CTA`)}
        </Button>
      }
    />
  );
}

export default GroupsEmptyState;
